"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let ContractTermEditor = class ContractTermEditor extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    getConfiguration(...args) {
        switch (this.mode) {
            case 'add':
                return {
                    isEditable: true,
                    isDeletable: false,
                    isTermReadonly: false,
                };
            case 'edit':
                return {
                    isEditable: !this.term.locked,
                    isDeletable: !this.term.locked,
                    isTermReadonly: this.term.locked,
                };
        }
    }
    contract;
    onContract(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("contract");
    }
    term;
    onTerm(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("term");
    }
    mode;
    onMode(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("mode");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    labelAlign;
    isEditable;
    async $$load_isEditable() {
        return this.getConfiguration().isEditable;
    }
    isDeletable;
    async $$load_isDeletable() {
        return this.getConfiguration().isDeletable;
    }
    isTermReadonly;
    async $$load_isTermReadonly() {
        return this.getConfiguration().isTermReadonly;
    }
    messages;
    item;
    async $$load_item() {
        return this.term || this.$fn.schemaDefaults('CreateContractTerm', {
            contract_id: this.contract.id
        });
    }
    currencies;
    async $$load_currencies() {
        return this.$fn.fetch('list_currency');
    }
    services;
    async $$load_services() {
        return this.$fn.fetch('suggest_product', {
            parameters: { query: '*', top: 50, skip: 0 }
        }).then(data => _.orderBy(data, [p => p.name.toLowerCase()]));
    }
    ux;
    b_7315092382398562_modalBindings;
    b_5731695935601903_dataSource;
    dataMembers = ['formId', 'labelAlign', 'isEditable', 'isDeletable', 'isTermReadonly', 'messages', 'item', 'currencies', 'services', 'ux', 'b_7315092382398562_modalBindings', 'b_5731695935601903_dataSource'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                formId: null,
                labelAlign: "right",
                isEditable: null,
                isDeletable: null,
                isTermReadonly: null,
                messages: {
                    add: {
                        title: this.$fn.pgettext("Contract|ModalHeader", "Add term"),
                    },
                    edit: {
                        title: this.$fn.pgettext("Contract|ModalHeader", "Edit term"),
                    },
                },
                item: null,
                currencies: null,
                services: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    noPrimaryButton: true,
                    closeButtonText: this.$fn.gettext("Close"),
                    size: "md",
                },
                b_5731695935601903_dataSource: {
                    name: "suggest_product",
                },
            },
        };
    }
    get currentObjectType() {
        if (this.loaded) {
            return "contract_term";
        }
        return null;
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.messages[this.mode].title,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_8702_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeModal_8708_getActionArgs($event) {
        return {
            result: {
                ok: true,
                value: $event.data,
            },
        };
    }
    async act_1040167445267876_crud_8706_getActionArgs($event) {
        return {
            objectType: this.currentObjectType,
            op: "upsert",
            data: this.item,
            options: {
                parameters: {
                    rev: this.contract.revision_number,
                },
            },
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async act_5731695935601903_setData_8710_getActionArgs($event) {
        return {
            path: "item.name",
            value: $event.data.option.name,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_5731695935601903_setData_8712_getActionArgs($event) {
        return {
            path: "item.service_id",
            value: $event.data.option.id,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_5731695935601903_setData_8714_getActionArgs($event) {
        return {
            path: "item.unit",
            value: $event.data.option.unit,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_5731695935601903_optionSelected(event, scope) {
        return await this.actions.evh_5731695935601903_optionSelected.executeFromDOM(this, event, scope);
    }
    async act_1548630417156826_closeModal_8718_getActionArgs($event) {
        return {
            result: {
                ok: true,
            },
        };
    }
    async act_1548630417156826_request_8716_getActionArgs($event) {
        return {
            operation: "delete_contract_term",
            data: this.item,
        };
    }
    async evh_1548630417156826_clickPreventStop(event, scope) {
        return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async evh_2186679009640457_clickPreventStop(event, scope) {
        return await this.actions.evh_2186679009640457_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_8702 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_8702_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_8701 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_8702,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_8701],
        });
        const act_2248226175642056_closeComponent_8704 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_8703 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_8704,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_8703],
        });
        const act_1040167445267876_closeModal_8708 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_8708_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_8707 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_8708,
            event: "success",
            displayName: "closeModal",
        });
        const act_1040167445267876_crud_8706 = new core_1.actions.CRUDAction({
            actionArgs: this.act_1040167445267876_crud_8706_getActionArgs,
            displayName: "save",
            events: [evh_1040167445267876_success_8707],
        });
        const evh_1040167445267876_submit_8705 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_crud_8706,
            event: "submit",
            displayName: "save",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_8705],
        });
        const act_5731695935601903_setData_8710 = new core_1.actions.SetDataAction({
            actionArgs: this.act_5731695935601903_setData_8710_getActionArgs,
            events: [],
        });
        const evh_5731695935601903_optionSelected_8709 = new core_1.actions.EventHandlerImpl({
            action: act_5731695935601903_setData_8710,
            event: "optionSelected",
            displayName: "setData",
        });
        const act_5731695935601903_setData_8712 = new core_1.actions.SetDataAction({
            actionArgs: this.act_5731695935601903_setData_8712_getActionArgs,
            events: [],
        });
        const evh_5731695935601903_optionSelected_8711 = new core_1.actions.EventHandlerImpl({
            action: act_5731695935601903_setData_8712,
            event: "optionSelected",
            displayName: "setData",
        });
        const act_5731695935601903_setData_8714 = new core_1.actions.SetDataAction({
            actionArgs: this.act_5731695935601903_setData_8714_getActionArgs,
            events: [],
        });
        const evh_5731695935601903_optionSelected_8713 = new core_1.actions.EventHandlerImpl({
            action: act_5731695935601903_setData_8714,
            event: "optionSelected",
            displayName: "setData",
        });
        const evh_5731695935601903_optionSelected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5731695935601903_optionSelected_8709, evh_5731695935601903_optionSelected_8711, evh_5731695935601903_optionSelected_8713],
        });
        const act_1548630417156826_closeModal_8718 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1548630417156826_closeModal_8718_getActionArgs,
            events: [],
        });
        const evh_1548630417156826_success_8717 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_closeModal_8718,
            event: "success",
            displayName: "closeModal",
        });
        const act_1548630417156826_request_8716 = new core_1.actions.RequestAction({
            actionArgs: this.act_1548630417156826_request_8716_getActionArgs,
            displayName: "deleteTerm",
            events: [evh_1548630417156826_success_8717],
        });
        const evh_1548630417156826_clickPreventStop_8715 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_request_8716,
            event: "click.prevent.stop",
            displayName: "deleteTerm",
        });
        const evh_1548630417156826_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1548630417156826_clickPreventStop_8715],
        });
        const act_2186679009640457_closeComponent_8720 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2186679009640457_clickPreventStop_8719 = new core_1.actions.EventHandlerImpl({
            action: act_2186679009640457_closeComponent_8720,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_2186679009640457_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2186679009640457_clickPreventStop_8719],
        });
        return {
            act_7315092382398562_closeModal_8702,
            evh_7315092382398562_close_8701,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_8704,
            evh_2248226175642056_close_8703,
            evh_2248226175642056_close,
            act_1040167445267876_closeModal_8708,
            evh_1040167445267876_success_8707,
            act_1040167445267876_crud_8706,
            evh_1040167445267876_submit_8705,
            evh_1040167445267876_submit,
            act_5731695935601903_setData_8710,
            evh_5731695935601903_optionSelected_8709,
            act_5731695935601903_setData_8712,
            evh_5731695935601903_optionSelected_8711,
            act_5731695935601903_setData_8714,
            evh_5731695935601903_optionSelected_8713,
            evh_5731695935601903_optionSelected,
            act_1548630417156826_closeModal_8718,
            evh_1548630417156826_success_8717,
            act_1548630417156826_request_8716,
            evh_1548630417156826_clickPreventStop_8715,
            evh_1548630417156826_clickPreventStop,
            act_2186679009640457_closeComponent_8720,
            evh_2186679009640457_clickPreventStop_8719,
            evh_2186679009640457_clickPreventStop,
            save: act_1040167445267876_crud_8706,
            deleteTerm: act_1548630417156826_request_8716,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], ContractTermEditor.prototype, "contract", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('contract'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ContractTermEditor.prototype, "onContract", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], ContractTermEditor.prototype, "term", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('term'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ContractTermEditor.prototype, "onTerm", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], ContractTermEditor.prototype, "mode", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('mode'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ContractTermEditor.prototype, "onMode", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], ContractTermEditor.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ContractTermEditor.prototype, "onSize", null);
ContractTermEditor = __decorate([
    (0, vue_property_decorator_1.Component)()
], ContractTermEditor);
exports.default = ContractTermEditor;
vue_property_decorator_1.Vue.component("ContractTermEditor", ContractTermEditor);
